import React from 'react';
import Facets from './Facets';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

class MobileFacets extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render() {
        const {
            attributes,
            onAttributeChange,
            onClearAttributes,
            showMobileFacets,
            onShowMobileFacetsChange,
            expandedFacets,
            onToggleFacetExpanded,
            showMoreFacets,
            onToggleShowMoreFacet,
            numberOfResults
        } = this.props;

        return (
            <div>
                {
                    showMobileFacets &&
                    <div className="mobile-facets-container container d-md-none">
                        <div className="row bg-light-gray">
                            <div className="col-12 d-flex align-items-center justify-content-between pr-0">
                                <h4 className="headline headline-xs mb-0">{translateResourceString("/SearchApp/MobileFacets/Header")}</h4>
                                <button type="button" className="btn btn-icon" aria-label="Close" onClick={() => onShowMobileFacetsChange(false)}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Facets
                                    attributes={attributes}
                                    onAttributeChange={onAttributeChange}
                                    onClearAttributes={onClearAttributes}
                                    expandedFacets={expandedFacets}
                                    onToggleFacetExpanded={onToggleFacetExpanded}
                                    updateOnToggle={true}
                                    showMoreFacets={showMoreFacets}
                                    onToggleShowMoreFacet={onToggleShowMoreFacet}
                                />
                            </div>
                        </div>
                        <div className="row see-results-button">
                            <div className="col-12">
                                <Button
                                    onClick={() => onShowMobileFacetsChange(false)}
                                    block
                                >{translateResourceString("/SearchApp/MobileFacets/ViewResults").replace("{0}", numberOfResults)}</Button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

MobileFacets.propType = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })).isRequired,
    onAttributeChange: PropTypes.func.isRequired,
    onClearAttributes: PropTypes.func.isRequired,
    showMobileFacets: PropTypes.bool.isRequired,
    onShowMobileFacetsChange: PropTypes.func.isRequired,
    expandedFacets: PropTypes.arrayOf(PropTypes.string).isRequired,
    onToggleFacetExpanded: PropTypes.func.isRequired,
    showMoreFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleShowMoreFacet: PropTypes.func,
    numberOfResults: PropTypes.number
};

export default MobileFacets;